import firestore, { firebase } from '@/firebase'

export default {
  state: {
    user: null,
    // school: null,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    snackbarTime: 5000,
    Delay: null,
    // IsIdle: false ,
    // as: null
  },
  getters: {
    // isIdle: state => state.isIdle,
    user: state => state.user,
    userDisplayName: state => state.user ? state.user.displayName : 'Gäst',
    schoolID: state => state.user.uid,
    As: state => state.user.As,   
    snackbar: state => state.snackbar,
    snackbarText: state => state.snackbarText,
    snackbarTime: state => state.snackbarTime,
    snackbarColor: state => state.snackbarColor
  },
  mutations: {
    SET_USER (state, user) {
      state.user = user
    },
    SHOW_SNACKBAR(state, show) {
      state.snackbar = show;
    },
    SET_SNACKBAR_TEXT(state, text) {
      state.snackbarText = text;
    },
    SET_SNACKBAR_TIME(state, time) {
      state.snackbarTime = time;
    },
    SET_SNACKBAR_COLOR(state, color) {
      state.snackbarColor = color;
    }
  },
  actions: {

    SHOWSNACKBAR({ commit }, show) {
      commit("SHOW_SNACKBAR", show);
    },

    showSuccessSnackbar({ state,commit }, msg) {
      if (state.Delay!=null) {
        clearTimeout(state.Delay);
      }
      commit("SET_SNACKBAR_TEXT", msg);
      commit("SET_SNACKBAR_TIME", 5000);
      commit("SET_SNACKBAR_COLOR", "success");
      commit("SHOW_SNACKBAR", true);
    },
    showSuccessSnackbarInfinity({ state,commit }, msg) {
      if (state.Delay!=null) {
        clearTimeout(state.Delay);
      }
      commit("SET_SNACKBAR_TEXT", msg);
      commit("SET_SNACKBAR_TIME", 0);
      commit("SET_SNACKBAR_COLOR", "success");
      commit("SHOW_SNACKBAR", true);
    },
    showTipSnackbar({ commit }, msg) {
      commit("SET_SNACKBAR_TEXT", msg);
      commit("SET_SNACKBAR_TIME", 5000);
      commit("SET_SNACKBAR_COLOR", "purple darken-1");
      commit("SHOW_SNACKBAR", true);
    },
    showOwnSnackbar({ commit }, data) {
      commit("SET_SNACKBAR_TEXT", data.msg);
      commit("SET_SNACKBAR_TIME", 5000);
      commit("SET_SNACKBAR_COLOR", data.color);
      commit("SHOW_SNACKBAR", true);
    },
    showWarningSnackbar({ commit }, msg) {
      commit("SET_SNACKBAR_TEXT", msg);
      commit("SET_SNACKBAR_TIME", 5000);
      commit("SET_SNACKBAR_COLOR", "warning");
      commit("SHOW_SNACKBAR", true);
    },
    showErrorSnackbar({ commit }, msg) {
      commit("SET_SNACKBAR_TEXT", msg);
      commit("SET_SNACKBAR_TIME", 5000);
      commit("SET_SNACKBAR_COLOR", "error");
      commit("SHOW_SNACKBAR", true);
    },

    showDelayErrorSnackbar({state, commit }, msg) {
     state.Delay= setTimeout(function() { 
        commit("SET_SNACKBAR_TEXT", msg);
        commit("SET_SNACKBAR_TIME", 5000);
        commit("SET_SNACKBAR_COLOR", "error");
        commit("SHOW_SNACKBAR", true);
       }, 500);

    },

    setUser ({ commit }, user) {
      commit('SET_USER', user)
    },
    
    logoutUser ({commit}) {
      return firebase.auth().signOut().then(() => {
        commit('SET_USER', null)
      })
    }
  }
}
